import { AxiosInstance, AxiosRequestConfig } from "axios";
import http from "../Http";
import { ExportableOrganisationApi } from "../exportableApi/ExportableOrganisationApiModel";
import { PlaceGroupsField } from "../../../../enums";
import { IFlightPathApiResponse } from "../BaseApiModel";

export class PlacesGroupsApi extends ExportableOrganisationApi<any> {
  controller: string = "place-groups";

  constructor(http: AxiosInstance) {
    super(http, "place-groups");
  }

  getPlaceGroups = async (organisationId: number, config?: any) => {
    let res = await this.http.get(`${this.url}/${organisationId}/place-groups`, config);
    return res.data;
  };

  updatePlaceGroupField = async (
    organisationId: number,
    projectId: number = null,
    placeGroupId: number,
    textField: string,
    idField: number,
    dateField: Date,
    numericField: number,
    field: PlaceGroupsField,
    config?: AxiosRequestConfig
  ): Promise<IFlightPathApiResponse<FP.Entities.IPlace>> => {
    let data = {
      TextField: textField,
      IdField: idField
    };

    let res = await this.http.put(
      `${this.url}/${organisationId}/${this.controller}/${placeGroupId}/${field}`,
      data,
      config
    );

    return res.data;
  };

  deleteRange = async (organisationId: number, placesGroupIds: number[], config?: AxiosRequestConfig) => {
    const res = await this.http.post(`${this.url}/${organisationId}/place-groups/delete-range`, placesGroupIds, config);
    return res.data;
  };

  bulkAdd = async (organisationId: number, placeGroupId: number, placeIds: number[], config?: AxiosRequestConfig) => {
    const res = await this.http.post(
      `${this.url}/${organisationId}/place-groups/bulk-add`,
      {
        placeGroupId: placeGroupId,
        placeIds: placeIds
      },
      config
    );
    return res.data;
  };
}

const instance = new PlacesGroupsApi(http);
export default instance;
